import axios from 'axios'

import type { ApiErrorShape } from './types'

export class ApiError extends Error implements ApiErrorShape {
  code: string
  status: number
  details?: unknown

  constructor(input: ApiErrorShape) {
    super(input.message)
    this.name = 'ApiError'
    this.code = input.code
    this.status = input.status
    this.details = input.details
  }
}

export function normalizeHttpError(error: unknown): ApiError {
  if (error instanceof ApiError) return error
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      { code?: string; message?: string; details?: unknown } | undefined
    return new ApiError({
      code: data?.code ?? (error.code || 'HTTP_ERROR'),
      message: data?.message ?? error.message ?? '网络请求失败',
      status: error.response?.status ?? 0,
      details: data?.details,
    })
  }
  return new ApiError({
    code: 'UNKNOWN_ERROR',
    message: error instanceof Error ? error.message : '未知错误',
    status: 0,
  })
}
